import { render, staticRenderFns } from "./AccountMenuProfileEntry.vue?vue&type=template&id=348dadc6"
import script from "./AccountMenuProfileEntry.vue?vue&type=script&lang=ts"
export * from "./AccountMenuProfileEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports